import { toast } from 'sonner';
import i18next from 'i18next';
import { ApiError } from '@repo/sdk';
import { getIntegrationErrorMessage } from '@/lib/integration-error-message.js';

export class LifecycleIntegration {
    constructor(sdkService) {
        this.service = sdkService;
    }

    async getOne(entityType, entityId) {
        try {
            const response = await this.service.getOne(entityType, entityId);
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(
                message
                || i18next.t('lifecycle:messages.fetchError', { defaultValue: 'Could not load lifecycle' }),
            );
            return { success: false, error: message, data: null };
        }
    }

    async bulkResolve(items) {
        try {
            const response = await this.service.bulk(items);
            return { success: true, data: response.data };
        } catch (error) {
            const message = this._getErrorMessage(error);
            toast.error(
                message
                || i18next.t('lifecycle:messages.fetchError', { defaultValue: 'Could not load lifecycle' }),
            );
            return { success: false, error: message, data: [] };
        }
    }

    _getErrorMessage(error) {
        return getIntegrationErrorMessage(error);
    }
}
